import type { communications as en } from '@/i18n/locales/en/communications';
import type { Translation } from '@/i18n/types';

export const communications: Translation<typeof en> = {
  page: {
    title: 'Comunicação',
    lead: 'Componha e agende notificações para {{company}}.',
    noScope: 'Selecione uma empresa para ver a sua comunicação.',
    forbidden: 'Não tem permissão para ver a comunicação desta empresa.',
  },
  composer: {
    title: 'Nova notificação',
    titleField: 'Título',
    message: 'Mensagem',
    category: 'Categoria',
    audience: 'Público-alvo',
    date: 'Data',
    time: 'Hora',
    callToAction: 'Apelo à ação',
    quietHours: 'Respeitar horas de silêncio',
    quietHoursHint: 'Atrasar a entrega fora das 08:00–20:00.',
    submit: 'Guardar como rascunho',
    schedule: 'Agendar',
    send: 'Enviar agora',
  },
  categories: {
    algemeen: 'Geral',
    veiligheid: 'Segurança',
    evenement: 'Evento',
    vitaliteit: 'Vitalidade',
    hr: 'RH',
  },
  audiences: {
    iedereen: 'Todos',
    management: 'Direção',
    per_afdeling: 'Por departamento',
    per_locatie: 'Por localização',
  },
  status: {
    concept: 'Rascunho',
    ingepland: 'Agendado',
    verzonden: 'Enviado',
  },
  log: {
    title: 'Registo de envios',
    empty: 'Ainda sem comunicação.',
    columns: {
      message: 'Mensagem',
      category: 'Categoria',
      reach: 'Alcance',
      openRate: 'Taxa de abertura',
      status: 'Estado',
    },
  },
  actions: {
    new: 'Nova notificação',
    cancel: 'Cancelar',
    markScheduled: 'Marcar como agendado',
    markSent: 'Marcar como enviado',
  },
};
